import React from "react";
import { NavigationLinks, Section } from "../../../../components";
import { SampleLinks, SampleButtons } from "../../sections";
import { ReactComponent as ImageNavigationLink } from "../../../../assets/images/catalogo/ilustracao-mulher-trofeu.svg";

const AcoesPage = () => {
  return (
    <>
      <Section as={SampleLinks} sectionName="Links de exemplos" />
      <Section as={SampleButtons} sectionName="Buttons de exemplos" />
      <Section
        sectionName="nome da secao analytics"
        as={NavigationLinks}
        image={<ImageNavigationLink />}
        sectionTitle="Outros exemplos"
      />
    </>
  );
};

AcoesPage.propTypes = {};

export default AcoesPage;
